// extracted by css-extract-rspack-plugin
export default {"switch":"switch-J0jBZi","disabled":"disabled-WsXxgT","input":"input-CgCbVO","track":"track-kitgME","thumb":"thumb-d5og76","label":"label-QJL8qx"};